module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Color-1d15050fcf072fb568d4ea19cc8e1626.svg";